const s = require("./config.module.scss");
import { default as React, useEffect, useState } from "react";

import { MonitoringConfigDto } from "core/backend/common";
import CheckIcon from "components/checkIcon";

interface OwnProps {
    dto: MonitoringConfigDto;
}

const ReadonlyRow = ({ dto }: OwnProps) => (
    <>
        <td className="alignLeft">{dto.page}</td>
        <td className="alignLeft">{dto.tableName}</td>
        <td className="alignLeft">{dto.fileType}</td>
        <td className="alignLeft">{dto.backupFileType}</td>
        <td className="alignLeft">{dto.spanningFile}</td>
        <td className="alignLeft">{dto.deadline}</td>
        <td><CheckIcon checked={dto.active} /></td>
    </>
);

export default ReadonlyRow;